export const EducationAndQualificationType = {
  CERTIFICATION: 'CERTIFICATION',
  ARCHIVED: 'ARCHIVED'
} as const;
export type EducationAndQualificationType = (typeof EducationAndQualificationType)[keyof typeof EducationAndQualificationType];